import React from 'react';
import { LeadsList } from '../components/leads/LeadsList';

export const LeadsPage: React.FC = () => {
  return <LeadsList />;
};